
import { Form, FormElement, RangeInput, StatusBlock } from '05-ui-kit';
import debounce from 'lodash.debounce';
import { computed, ref } from '@vue/composition-api';
import { formatPrice } from '@artmizu/utils';
import type { ResponseError } from '~/type/Error';
import type { Calculate, InstallmentParams } from '~/type/Installment';
interface Props {
  loading?: boolean;
  error?: ResponseError;
  initialState: InstallmentParams;
  data: Calculate;
}
const __sfc_main = {};
__sfc_main.props = {
  loading: {
    key: "loading",
    required: false,
    type: Boolean,
    default: false
  },
  error: {
    key: "error",
    required: false,
    type: null
  },
  initialState: {
    key: "initialState",
    required: true,
    type: null
  },
  data: {
    key: "data",
    required: true,
    type: null
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const initialPercent = computed(() => Number(props.initialState.price) > 110000 ? 45 : 30);
  const installmentSettings = ref({
    price: props.initialState.price,
    first_fee_in_rouble: Math.ceil(props.initialState.price * initialPercent.value / 100),
    period: props.initialState.period
  });
  const debounceChange = debounce(onChange, 500);
  function onChange(type: 'price' | 'first_fee_in_rouble' | 'period', value: number) {
    installmentSettings.value[type] = value;
    emit('update', {
      type: type === 'first_fee_in_rouble' ? 'firstfee' : type,
      value: installmentSettings.value
    });
  }
  const firstFeeRange = computed(() => {
    return {
      min: Math.ceil(installmentSettings.value.price * initialPercent.value / 100),
      max: Math.ceil(installmentSettings.value.price * props.data.initialPercent.max / 100)
    };
  });
  const summaryList = computed(() => {
    return [{
      text: 'Стоимость товара в рассрочку',
      value: props?.data.grade?.total ? formatPrice(Math.ceil(props?.data.grade?.total)) : '-'
    }, {
      text: 'Переплата по договору',
      value: props?.data.grade?.overpayment ? formatPrice(Math.ceil(props?.data.grade?.overpayment)) : '-'
    }];
  });
  const totalText = computed(() => props.data.grade?.payments ? formatPrice(Math.ceil(props.data.grade?.payments)) : '-');
  return {
    emit,
    installmentSettings,
    debounceChange,
    firstFeeRange,
    summaryList,
    totalText
  };
};
__sfc_main.components = Object.assign({
  Form,
  FormElement,
  RangeInput,
  StatusBlock
}, __sfc_main.components);
export default __sfc_main;
